/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import _ from 'lodash';

import { MOBILE_WIDTH } from '../../constants/SizeConstants';
import { decodeString } from '../../utils/commonUtils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';

const getQueryString = (queryStringParam) => {
  const results = new RegExp(`[\\?&]${queryStringParam}=([^&#]*)`, 'i').exec(window.location.href);
  if (!results) {
    return '';
  }
  return results[1] || '';
};

const preprocessRegexStr = (regexStr) => {
  if (isNilOrEmpty(regexStr)) {
    return regexStr;
  }
  let preparedRegex = unescape(regexStr);
  let str2;
  do {
    str2 = preparedRegex;
    preparedRegex = decodeString(regexStr);
  } while (preparedRegex !== str2);
  return preparedRegex;
};

export const getOrgUnitParent = (orgHierarchy, type) => {
  const orgUnitIndex = orgHierarchy.findIndex((item) => item.toLowerCase() === type.toLowerCase());

  return orgUnitIndex === -1 || isNilOrEmpty(orgHierarchy[orgUnitIndex - 1])
    ? 'N/A'
    : orgHierarchy[orgUnitIndex - 1];
};

// expression editor functions
var ss = {
  isMobileDevice() {
    return window.screen.availWidth <= MOBILE_WIDTH;
  },

  parentOrgUnitLevel(ssContext, type) {
    if (!isNilOrEmpty(type)) {
      const orgHierarchy = Object.values(ssContext.orgHierarchy);

      const parent = getOrgUnitParent(orgHierarchy, type);

      const parentLevel =
        parent === 'N/A'
          ? parent
          : orgHierarchy.findIndex((item) => item.toLowerCase() === parent.toLowerCase()) + 1;

      return parentLevel.toString();
    } else {
      return 'N/A';
    }
  },
  parentOrgUnitType(ssContext, type) {
    if (!isNilOrEmpty(type)) {
      const orgHierarchy = Object.values(ssContext.orgHierarchy);

      return getOrgUnitParent(orgHierarchy, type);
    } else {
      return 'N/A';
    }
  },

  loggedOnDomain(data) {
    return data.formInfo.userContext.f_LogonUserIdentity.split('@')[1];
  },

  today() {
    const date = new Date();

    date.setHours(0, 0, 0, 0);

    return date;
  },

  now() {
    const date = new Date();

    return date;
  },

  getFormTranslation(translations, formTranslationKey) {
    // search in translations.Form
    if (translations && translations.Form && translations.Form[formTranslationKey]) {
      return translations.Form[formTranslationKey];
    }
    // search in translations.Entity
    if (translations && translations.Entity && translations.Entity[formTranslationKey]) {
      return translations.Entity[formTranslationKey];
    }
    // console.log('getFormTranslation() no translation for ' + formTranslationKey);
    return formTranslationKey; // fallback
  },

  actorCode(data) {
    return data.formInfo.userContext.f_ActorCode;
  },

  actorFullName(data) {
    return data.formInfo.userContext.f_ActorFullName;
  },

  culture(data) {
    return data.formInfo.userContext.f_Culture;
  },

  orgUnitCode(data) {
    return data.formInfo.userContext.f_CurrentOrgUnitCode;
  },

  orgUnitId(data) {
    return data.formInfo.userContext.f_CurrentOrgUnitID;
  },

  loggedOnOrgCode(data) {
    return data.formInfo.userContext.f_LoggedOnOrganizationCode;
  },

  orgUnit1Id(data) {
    return data.formInfo.userContext.f_OrgUnit1Id;
  },

  orgUnit1Code(data) {
    return data.formInfo.userContext.f_OrgUnit1Code;
  },

  orgUnit1Name(data) {
    return data.formInfo.userContext.f_OrgUnit1Name;
  },

  orgUnit2Id(data) {
    return data.formInfo.userContext.f_OrgUnit2Id;
  },

  orgUnit2Code(data) {
    return data.formInfo.userContext.f_OrgUnit2Code;
  },

  orgUnit2Name(data) {
    return data.formInfo.userContext.f_OrgUnit2Name;
  },

  orgUnit3Id(data) {
    return data.formInfo.userContext.f_OrgUnit3Id;
  },

  orgUnit3Code(data) {
    return data.formInfo.userContext.f_OrgUnit3Code;
  },

  orgUnit3Name(data) {
    return data.formInfo.userContext.f_OrgUnit3Name;
  },

  userCode(data) {
    return data.formInfo.userContext.f_LogonUserIdentity;
  },

  roleCode(data) {
    return data.formInfo.userContext.f_CurrentRoleCode;
  },

  roleName(data) {
    return data.formInfo.userContext.f_CurrentRoleName;
  },

  actorTitle(data) {
    return data.formInfo.userContext.f_ActorTitle;
  },

  siteCode(data) {
    return data.formInfo.userContext.f_SiteCode;
  },

  siteId(data) {
    return data.formInfo.userContext.f_SiteId;
  },

  siteName(data) {
    return data.formInfo.userContext.f_SiteName;
  },

  stepName(data) {
    return data.formInfo.stepName;
    // return "Verify CAPA Initiation"; // formInfo.stepName;
  },

  translatedStepName(data) {
    return data.formInfo.translatedStepName;
  },

  stepId(data) {
    return data.formInfo.stepId;
  },

  workflowId(data) {
    return data.formInfo.workflowId;
  },

  workflowKey(data) {
    return data.formInfo.workflowKey;
  },

  containerWorkflowKey(data) {
    return data.formInfo.containerWorkflowKey;
  },

  rowCount(ssContext, data, dataMember, templateName) {
    return ssContext.rowCountImpl(ssContext, data, dataMember, templateName);
  },

  rowCountWithFilter(ssContext, data, dataMember, filterStr) {
    return ssContext.rowCountWithFilterImpl(ssContext, data, dataMember, filterStr);
  },

  stringFormat() {
    // only execute if first argument is string
    if (arguments[0] && typeof arguments[0] === 'string') {
      // convert arguments to an array
      const args = Array.prototype.slice.call(arguments, 0);
      args.splice(0, 1);
      let s = arguments[0];
      const lastArgument = arguments[arguments.length - 1];
      const isHyperlinkUrl = _.isObject(lastArgument) ? lastArgument.isHyperlinkUrl : false;
      let i = isHyperlinkUrl ? args.length - 1 : args.length;

      while (i--) {
        const argValue = args[i] && isHyperlinkUrl ? encodeURIComponent(args[i]) : args[i];
        s = s.replace(new RegExp(`\\{${i}\\}`, 'gm'), argValue ?? null);
      }
      return s;
    }

    return null;
  },

  hasRight(data, rightName) {
    // return true;
    return (
      data.formInfo.userContext &&
      // eslint-disable-next-line no-prototype-builtins
      data.formInfo.userContext.f_CurrentRights.hasOwnProperty(rightName) &&
      data.formInfo.userContext.f_CurrentRights[rightName] === true
    );
  },

  hasRole(data, ssContext, roleCode) {
    const userRoles = ssContext.userRoles || [];
    return data.formInfo.currentRoles[roleCode] || userRoles.includes(roleCode);
  },

  isModuleInstalled(ssContext, moduleName) {
    const { installedVersions } = ssContext;

    return installedVersions.some(
      (installedModule) =>
        installedModule.Description.replace(' ', '').startsWith(moduleName) ||
        installedModule.Version.replace(' ', '').startsWith(moduleName)
    );
  },

  isEqual(leftValue, rightValue) {
    if (typeof leftValue === 'object' && leftValue.constructor === Date) {
      leftValue = leftValue.valueOf();
    }
    if (typeof rightValue === 'object' && rightValue.constructor === Date) {
      rightValue = rightValue.valueOf();
    }

    return leftValue === rightValue;
  },

  checkExpression(expression, value, modifier) {
    // add default modifier if none is specified
    if (!modifier) {
      modifier = 'gi';
    }
    const preprocessedRegexStr = preprocessRegexStr(expression);
    // create reg expression and test with value
    const regExp = new RegExp(preprocessedRegexStr, modifier);
    return regExp.test(value);
  },

  startsWith(leftValue, rightValue) {
    return cm_complexOperator('SW', leftValue, rightValue);
  },

  endsWith(leftValue, rightValue) {
    return cm_complexOperator('EW', leftValue, rightValue);
  },

  contains(leftValue, rightValue) {
    return cm_complexOperator('CT', leftValue, rightValue);
  },

  dateAdd(unit, amt, date) {
    if (date === null) {
      return null;
    }
    const d = new Date(date);
    const res = new Date(date);
    if (d !== 'Invalid Date') {
      switch (unit.toLowerCase()) {
        case 'ms':
          res.setTime(d.getTime() + amt);
          break;
        case 's':
          res.setTime(d.getTime() + amt * 1000);
          break;
        case 'i':
          res.setTime(d.getTime() + amt * 1000 * 60);
          break;
        case 'h':
          res.setTime(d.getTime() + amt * 1000 * 60 * 60);
          break;
        case 'd':
          res.setTime(d.getTime() + amt * 1000 * 60 * 60 * 24);
          break;
        case 'w':
          res.setTime(d.getTime() + amt * 1000 * 60 * 60 * 24 * 7);
          break;
        case 'y':
          res.setTime(d.getTime() + amt * 1000 * 60 * 60 * 24 * 365);
          break;
        default:
          return 0;
      }
    } else {
      return null;
    }
    // difference adjusted for daylight savings
    const dlsAdjustment = (res.getTimezoneOffset() - d.getTimezoneOffset()) * 60 * 1000;
    res.setTime(res.getTime() + dlsAdjustment);
    return res;
  },

  dateDiff(unit, startDate, endDate) {
    let res;
    const sd = new Date(startDate);
    const ed = new Date(endDate);
    if (sd !== 'Invalid Date' && ed !== 'Invalid Date') {
      const diff = ed.getTime() - sd.getTime();
      const dlsAdjustment = (sd.getTimezoneOffset() - ed.getTimezoneOffset()) * 60 * 1000;
      // difference adjusted for daylight savings
      switch (unit.toLowerCase()) {
        case 'ms':
          res = diff + dlsAdjustment;
          break;
        case 's':
          res = (diff + dlsAdjustment) / 1000;
          break;
        case 'i':
          res = (diff + dlsAdjustment) / (1000 * 60);
          break;
        case 'h':
          res = (diff + dlsAdjustment) / (1000 * 60 * 60);
          break;
        case 'd':
          res = (diff + dlsAdjustment) / (1000 * 60 * 60 * 24);
          break;
        case 'w':
          res = (diff + dlsAdjustment) / (1000 * 60 * 60 * 24 * 7);
          break;
        case 'y':
          res = (diff + dlsAdjustment) / (1000 * 60 * 60 * 24 * 365);
          break;
        default:
          res = diff + dlsAdjustment;
      }
    } else {
      return 0;
    }
    return res;
  },

  dateAddBusinessDays(ssContext, numberOfDaysToAdd, startDate, siteCode) {
    const date = ssContext.getDateAddBusinessDaysImpl(
      ssContext,
      numberOfDaysToAdd,
      startDate,
      siteCode
    );

    if (date === null) {
      return null;
    }

    const resultDate = new Date(date);

    if (resultDate === 'Invalid Date') {
      return null;
    }

    return resultDate;
  },

  getApplicationSetting(ssContext, key) {
    const { appSettings } = ssContext;
    return appSettings[key];
  },

  getQueryStringParam(paramValue, context) {
    // default context to this window
    if (context === undefined) {
      context = window;
    }

    const value = getQueryString(paramValue);
    return value;
  },

  buildGridTitle(ssContext, translatedLabel, data, dataMember, templateName) {
    // ss.rowCount('V_SS_CAPA', 'V_SS_CAPA-V_BAH_BASE_ATTACHMENT_GEN', 'Grid1-Attachment'))
    return ss.stringFormat(
      '{0} ({1})',
      translatedLabel,
      ss.rowCount(ssContext, data, dataMember, templateName)
    );
  },

  buildRowTitle(
    ssContext,
    data,
    translatedLabel,
    dataMember,
    childDataMember,
    dataRow,
    templateName
  ) {
    return ss.stringFormat(
      '{0} ({1} of {2})',
      translatedLabel,
      ss.rowIndex(ssContext, dataRow, templateName) + 1,
      ss.rowCount(ssContext, data, dataMember, childDataMember, templateName)
    );
  },

  convertArrayToDoublePipeDelimitedString(
    ssContext,
    data,
    childDataMember,
    columnName,
    templateName
  ) {
    return ssContext.convertArrayToDoublePipeDelimitedStringImpl(
      ssContext,
      data,
      childDataMember,
      columnName,
      templateName
    );
  },

  getEntityDataStore(data) {
    // TODO: return subtree ? (method never tested)
    return data; // pageClientManager._dataStore.entityData;
  },

  rowIndex(ssContext, dataRow, templateName) {
    return ssContext.rowIndexImpl(ssContext, dataRow, templateName);
  },

  getCurrentRowValue(ssContext, data, dataField, nullValue) {
    return ssContext.getCurrentRowValueImpl(ssContext, data, dataField, nullValue);
  },

  columnValueNotUnique(ssContext, currentRow, columnName, templateName) {
    return ssContext.columnValueNotUniqueImpl(ssContext, currentRow, columnName, templateName);
  },

  previousRowValue(dataRow, valuePath, templateName) {
    // TODO: implement me (never used)
    console.log(' ss.previousRowValue() is not implemented ');

    return null;
  },

  getSupportData(data, dataSourceKey, filter) {
    const supportSource = [];

    // TODO: implement me
    console.log(' ss.getSupportData() is not implemented ');

    return supportSource;
  },

  min(ssContext, data, childDataMember, columnName, templateName) {
    return ssContext.minImpl(ssContext, data, childDataMember, columnName, templateName);
  },

  minimumValue(ssContext, data, childDataMember, columnName, templateName) {
    return ssContext.minimumValueImpl(ssContext, data, childDataMember, columnName, templateName);
  },

  minWithFilter(ssContext, data, childDataMember, columnName, filterStr) {
    return ssContext.minWithFilterImpl(ssContext, data, childDataMember, columnName, filterStr);
  },

  max(ssContext, data, childDataMember, columnName, templateName) {
    return ssContext.maxImpl(ssContext, data, childDataMember, columnName, templateName);
  },

  maxWithFilter(ssContext, data, childDataMember, columnName, filterStr) {
    return ssContext.maxWithFilterImpl(ssContext, data, childDataMember, columnName, filterStr);
  },

  sum(ssContext, data, childDataMember, columnName, templateName) {
    return ssContext.sumImpl(ssContext, data, childDataMember, columnName, templateName);
  },

  sumWithFilter(ssContext, data, childDataMember, columnName, filterStr) {
    return ssContext.sumWithFilterImpl(ssContext, data, childDataMember, columnName, filterStr);
  },

  columnValueWithFilter(ssContext, data, childDataMember, columnName, filterStr) {
    return ssContext.columnValueWithFilterImpl(
      ssContext,
      data,
      childDataMember,
      columnName,
      filterStr
    );
  },

  getStatus(workflowName, startPhaseName, startStepName, endPhaseName, endStepName) {
    // TODO: implement me (never used)
    console.log(' ss.getStatus() is not implemented ');

    const cTaskDisplayStatusStarted = 'taskDisplayStatusStarted';
    const returnStatus = cTaskDisplayStatusStarted;

    return returnStatus;
  },

  currentRecordId(ssContext) {
    return ssContext.currentRecordIdImpl(ssContext);
  },
  getNumberingScheme(ssContext, numberingSchemeCode = '', orgList = []) {
    return ssContext.getNumberingSchemeImpl(ssContext, numberingSchemeCode, orgList);
  },

  isModuleLicensed(ssContext, moduleName) {
    return ssContext.getLicensedModuleImpl(ssContext, moduleName);
  },

  evaluateDynamicFormula(ssContext, data, target) {
    return ssContext.evaluateDynamicFormulaImpl(ssContext, data, target);
  },
};

export const cm_complexOperator = (operator, leftValue, rightValue) => {
  // do not eval if either side is null
  if (leftValue === null || rightValue === null) {
    return false;
  }

  switch (operator) {
    case 'SW':
      return leftValue.startsWith(rightValue);
    case 'EW':
      return leftValue.endsWith(rightValue);
    case 'CT':
      return leftValue.toLowerCase().indexOf(rightValue.toLowerCase()) !== -1;
    default:
  }
};

export default ss;
